/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react'
import DraftEditor from 'draft-js-plugins-editor'
import createLinkifyPlugin from 'draft-js-linkify-plugin'
import createLinkPlugin from 'draft-js-anchor-plugin'
import createToolbarPlugin from 'draft-js-static-toolbar-plugin'

import {
    ItalicButton,
    BoldButton,
    UnderlineButton,
    HeadlineOneButton,
    UnorderedListButton,
    OrderedListButton,
} from 'draft-js-buttons'
import styles from './editorStyles.module.css'
import regex from '../regex'
import AnalysisBox from '../AnalysisBox/AnalysisBoxContainer'
import debounce from 'lodash.debounce'
import { calculateBiasScore } from './utils/calculateBiasScore'
import { calculateAggregateScores } from './utils/calculateAggregateScores'
import { getGenderBalance } from './utils/getGenderBalance'
import { getReadingEase } from './utils/getReadingEase'
import { composeDecorators } from 'draft-js-plugins-editor'
import FeminineSpan from '../FeminineSpan/FeminineSpanContainer'
import MasculineSpan from '../MasculineSpan/MasculineSpanContainer'
import BullshitSpan from '../BullshitSpan/BullshitSpanContainer'
import ExperienceSpan from '../ExperienceSpan/ExperienceSpanContainer'
import EducationSpan from '../EducationSpan/EducationSpanContainer'
import CapsSpan from '../CapsSpan/CapsSpanContainer'
import MustSpan from '../MustSpan/MustSpanContainer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faFileExport
} from '@fortawesome/pro-light-svg-icons'
import { AppliedTooltip as Tooltip, BaseSpan } from '../AppliedTooltip/AppliedTooltip'


import exportUtils from './utils/export'
import { stateToHTML } from 'draft-js-export-html'

const linkPlugin = createLinkPlugin()
const linkifyPlugin = createLinkifyPlugin({ target: '_blank' })
const toolbarPlugin = createToolbarPlugin({
    theme: {
        toolbarStyles: {
            toolbar: styles.toolbar,
        },
        buttonStyles: {
            button: styles.toolbarButton,
            buttonWrapper: styles.toolbarButtonWrapper,
            active: styles.toolbarButtonActive,
        }
    },
})

const { Toolbar } = toolbarPlugin
const plugins = [linkPlugin, linkifyPlugin, toolbarPlugin]

const findWithRegexNew = (regex, contentBlock, callback) => {
    const text = contentBlock.getText()
    let matchArr, start

    while ((matchArr = regex.exec(text)) !== null) {
        if (matchArr[1]) {
            const wordLength = matchArr[1].length
            start = matchArr.index

            callback(start, start + wordLength)
        }
    }
}

const findWithRegex = (regex, contentBlock, callback) => {
    const text = contentBlock.getText()
    let matchArr, start

    while ((matchArr = regex.exec(text)) !== null) {
        const wordLength = matchArr[0].length
        start = matchArr.index

        callback(start, start + wordLength)
    }
}

export default class Editor extends Component {
    constructor(props) {
        super(props)
        this.handleChange = debounce(this.handleChange, 770)
    }
    state = {
        maleCount: 0,
        maleWords: [],
        femaleCount: 0,
        femaleWords: [],
        allText: [],
        readability: 0,
        mustCount: 0,
        capsCount: 0,
        countCorporate: 0,
        countExperience: 0,
        countEducation: 0,
        wordCount: 0,
        scores: {
            inclusion: {
                gender: { score: 0 },
                musthaves: { score: 0 },
                inhibiting: { score: 0 },
                education: { score: 0 },
                score: 0,
            },
            conversion: {
                readability: { score: 0 },
                wordcount: { score: 0 },
                buzzwords: { score: 0 },
                acronyms: { score: 0 },
                score: 0,
            },
        },
        experimentalSectionOpen: false,
        pluginsInitialised: false
    }

    ignoreCaps = () => {
        const ignoreArrayDefaults = ['ASOS', 'ABC', 'JM', 'JM&A', 'SETF', 'SET', 'HFC']
        const fullIgnoreList = ignoreArrayDefaults.concat(this.props.ignoreWords)

        return `(?!\\b${fullIgnoreList.join('\\b|')}\\b)`
    }

    capsRegex = () =>
        new RegExp(`\\b${this.ignoreCaps()}(\\b[A-Z&]{2,}\\b)\\b`, 'g')


    masculineStrategy = (contentBlock, callback, contentState) => {
        findWithRegex(regex.masculineRegex, contentBlock, callback)
    }

    bullshitStrategy = (contentBlock, callback, contentState) => {
        findWithRegex(regex.bullshitRegex, contentBlock, callback)
    }

    capsStrategy = (contentBlock, callback, contentState) => {
        findWithRegex(this.capsRegex(), contentBlock, callback)
    }

    experienceStrategy = (contentBlock, callback, contentState) => {
        findWithRegexNew(regex.experienceRegex, contentBlock, callback)
    }

    educationStrategy = (contentBlock, callback, contentState) => {
        findWithRegex(regex.educationRegex, contentBlock, callback)
    }

    feminineStrategy = (contentBlock, callback, contentState) => {
        findWithRegex(regex.feminineRegex, contentBlock, callback)
    }

    mustStrategy = (contentBlock, callback, contentState) => {
        findWithRegexNew(regex.mustRegex, contentBlock, callback)
    }

    decorators = composeDecorators([
        {
            strategy: this.masculineStrategy,
            component: MasculineSpan,
        },
        {
            strategy: this.feminineStrategy,
            component: FeminineSpan,
        },
        {
            strategy: this.bullshitStrategy,
            component: BullshitSpan,
        },
        {
            strategy: this.experienceStrategy,
            component: ExperienceSpan,
        },
        {
            strategy: this.educationStrategy,
            component: EducationSpan,
        },
        {
            strategy: this.mustStrategy,
            component: MustSpan,
        },
        {
            strategy: this.capsStrategy,
            component: CapsSpan,
        },
    ])

    componentDidMount() {
        // The LinkButton component tries to render before the plugins have been initialised
        this.setState({
            pluginsInitialised: true,
        })
    }

    componentDidUpdate(prevProps) {
        if (this.props.editorState !== prevProps.editorState) {
            this.handleChange(
                this.props.editorState.getCurrentContent().getBlockMap(),
            )
        }
    }

    count(text, regex, whitelist) {
        let matches = text.match(regex)
        return matches ? matches.length : 0
    }

    newCount(text, regex, whitelist) {
        let countMatches = 0
        let matchArr

        while ((matchArr = regex.exec(text)) !== null) {
            if (matchArr[1]) {
                countMatches++
            }
        }
        return countMatches
    }

    wordsWithType(words, type) {
        return words.filter(word => {
            return word.type === type
        })
    }

    calculateScores(text) {
        const words = text ? text.replace(/\n/g, ' ').split(' ') : []

        this.setState({
            allText: text,
            mustCount: this.newCount(text, regex.mustRegex),
            countCorporate: this.count(text, regex.bullshitRegex),
            countExperience: this.newCount(text, regex.experienceRegex),
            capsCount: this.count(text, this.capsRegex()),
            countEducation: this.count(text, regex.educationRegex),
            wordCount: words.length,
        })

        Promise.all([
            getReadingEase(text.replace(/\n/g, '. ')).then(response => {
                if (response.data.text.length > 1) {
                    this.setState({ readability: response.data.readingScore })
                }
            }),
            getGenderBalance(text).then(response => {
                const maleWords = this.wordsWithType(
                    response.data.result,
                    'masculine',
                )
                const femaleWords = this.wordsWithType(
                    response.data.result,
                    'feminine',
                )
                this.setState({
                    maleWords,
                    maleCount: maleWords.length,
                    femaleWords,
                    femaleCount: femaleWords.length,
                })
            }),
        ])
            .then(() => {
                this.setState({ scores: calculateAggregateScores(this.state) })
            })
            .catch(function(error) {
                console.log(error)
            })
    }

    handleChange(text) {
        const plainText = this.props.editorState
            .getCurrentContent()
            .getPlainText()
        let allText = []
        text.map(contentBlock => {
            const blockText = contentBlock.text
            if (blockText !== blockText.toUpperCase()) allText.push(blockText)
            return blockText
        })
        this.calculateScores(plainText)
    }

    onChange = editorState => {
        this.props.saveEditorText(editorState)
        this.handleChange(editorState.getCurrentContent().getBlockMap())
    }

    toggleExperimentalSection = () => {
        this.setState({
            experimentalSectionOpen: !this.state.experimentalSectionOpen,
        })
    }

    onExport = editorState => {
        exportUtils.Export2Doc(
            stateToHTML(this.props.editorState.getCurrentContent()),
        )
    }

    render() {
        return <div className={styles.editor}>
                <div className={styles.editorPane} id="draftEditor">
                    <div className={styles.toolbarContainer}>
                        {this.state.pluginsInitialised && <Toolbar>
                                {childProps => <React.Fragment>
                                        <ItalicButton {...childProps} />
                                        <BoldButton {...childProps} />
                                        <UnderlineButton {...childProps} />
                                        <HeadlineOneButton {...childProps} />
                                        <UnorderedListButton {...childProps} />
                                        <OrderedListButton {...childProps} />
                                        <linkPlugin.LinkButton {...childProps} />
                                    </React.Fragment>}
                            </Toolbar>}
                        <div className={styles.exportContainer} onClick={this.onExport}>
                            <Tooltip popoverContent={'Export as .doc'}>
                                <BaseSpan color="#FFFFFF" borderColor="#FFFFFF" offsetKey={'bottom'}>
                                    <FontAwesomeIcon size="lg" icon={faFileExport} className={styles.exportIcon} />{' '}
                                </BaseSpan>
                            </Tooltip>
                        </div>
                    </div>
                    <div className={styles.editorContainer}>
                        <DraftEditor ref="editor" editorState={this.props.editorState} onChange={this.onChange} plugins={plugins} decorators={this.decorators} spellCheck placeholder="Start writing your job description here to get going..." ariaLabel="Text analysis editor" />
                    </div>
                </div>
                <div className={styles.analysisPane}>
                    <AnalysisBox maleCount={this.state.maleCount} femaleCount={this.state.femaleCount} maleWords={this.state.maleWords} femaleWords={this.state.femaleWords} bias={calculateBiasScore(this.state.maleCount, this.state.femaleCount)} readingEase={this.state.readability} mustCount={this.state.mustCount} capsCount={this.state.capsCount} editorEmpty={this.state.allText.length < 1} countCorporate={this.state.countCorporate} countExperience={this.state.countExperience} countEducation={this.state.countEducation} wordCount={this.state.wordCount} inclusionScore={this.state.scores.inclusion.score} conversionScore={this.state.scores.conversion.score} />
                </div>
            </div>
    }
}
